import { render, staticRenderFns } from "./addProp.vue?vue&type=template&id=40fa8232&scoped=true&"
import script from "./addProp.vue?vue&type=script&lang=js&"
export * from "./addProp.vue?vue&type=script&lang=js&"
import style0 from "./addProp.vue?vue&type=style&index=0&id=40fa8232&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fa8232",
  null
  
)

export default component.exports